import type { IntlShape } from 'react-intl';

/** Localized date + time parts for the credit allowance reset caption. */
export function formatCreditAllowanceResetCaption(
  intl: IntlShape,
  cycleEnd: string
): { date: string; time: string } {
  const resetAt = new Date(cycleEnd);

  return {
    date: intl.formatDate(resetAt, { month: 'short', day: 'numeric' }),
    time: intl.formatDate(resetAt, {
      hour: 'numeric',
      minute: '2-digit',
    }),
  };
}

/** Localized cycle end date (`en`: `Oct 28, 2026`) for complimentary usage copy. */
export function formatCreditAllowanceCycleEndDate(
  intl: IntlShape,
  cycleEnd: string
): string {
  return intl.formatDate(new Date(cycleEnd), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
